import { render, staticRenderFns } from "./v-placeholder.vue?vue&type=template&id=099660b6&scoped=true&"
var script = {}
import style0 from "./v-placeholder.vue?vue&type=style&index=0&id=099660b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099660b6",
  null
  
)

export default component.exports